import COUNTRY_OPTIONS from 'constants/countryOptions';

const getCountryFromLocale = () => {
  const parsedLanguage = /^\w{1,2}-(\w{1,2})$/.exec(navigator.language);
  if (!parsedLanguage) {
    return '';
  }

  const [, countryCode] = parsedLanguage;
  const countryCodeValid = COUNTRY_OPTIONS.some(({ value }) => value === countryCode);
  return countryCodeValid ? countryCode : '';
};

export default getCountryFromLocale;
